import { Lightning, Registry } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { urlWithRecipe } from '../../Business/utility/ImageRecipeUtil';
import { CmsBorder } from './CmsBorder';
import { CmsConstants } from '../../Business/cms/CmsConstants';
import { CmsActionResolver } from '../../Business/cms/cardResolver/CmsActionResolver';
import { CmsDotBar } from './CmsDotBar';
import { CmsBannerImage } from './CmsBannerImage';

const _constants = {
  cornerRadius: 8,
  rightMargin: 68,
  topMargin: 20,
  bottomMargin: 10,
  progressBarBottomMargin: 10,
  dotWidth: 30,
  dotSpacing: 5,
  dotVerticalMargin: 4,
};

export class CmsBanner extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      color: Theme.Colors.Transparent,
      rect: true,
      ImageContainer: {
        y: _constants.topMargin,
        w: w => w,
        h: h => h,
        color: Theme.Colors.Transparent,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.cornerRadius,
        },
      },
      DotBar: {
        type: CmsDotBar,
        mountX: 0.5,
        mountY: 1,
        x: w => w * 0.5,
        y: y => y - _constants.bottomMargin - _constants.progressBarBottomMargin,
      },
      Border: {
        y: _constants.topMargin,
        h: h => h - _constants.topMargin - _constants.bottomMargin,
        type: CmsBorder,
        visible: false,
      },
    };
  }

  _init() {
    this.ImageContainer = this.tag('ImageContainer');
    this.DotBar = this.tag('DotBar');
    if (this.fadeOut === undefined) this.fadeOut = true;
    this.alpha = this.fadeOut ? CmsConstants.Animation.fadeOut : 1;
    this._ImageIndex = 0;
    this.patch({
      ImageContainer: {
        x: this.contentOffset,
        w: w => w - this.contentOffset - _constants.rightMargin,
      },
      Border: {
        x: this.contentOffset,
        w: w => w - this.contentOffset - _constants.rightMargin,
      },
    });
  }

  _firstActive() {
    // console.log(this.data);
    if (this.data.banners.length > 0) {
      // Place all images on banner and make them invisible
      this.data.banners.forEach(banner => {
        const imageUrl = urlWithRecipe(banner.image, this.data.recipe);
        if (imageUrl) {
          this.ImageContainer.childList.a({
            type: CmsBannerImage,
            w: w => w,
            h: h => h,
            banner,
            imageUrl,
            alpha: 0,
          });
        }
      });
      this.DotBar.patch({
        x: w => this.contentOffset + (w - this.contentOffset - _constants.rightMargin) * 0.5,
      });
      this.ImageContainer.childList.getAt(0).setSmooth('alpha', 1); // Make first Image visible
      this.DotBar.amount = this.ImageContainer.childList.length; // Set DotBar amount of dots
      this.DotBar.updateUI(0, 0); // Activate first Dot

      let width = this.finalW - this.contentOffset - _constants.rightMargin;
      let imgHeight = this.data.heightForWidth(width);
      this.ImageContainer.h = imgHeight;
      this.h = _constants.topMargin + imgHeight + _constants.bottomMargin;

      if (this.data.banners.length === 1) {
        this.DotBar.visible = false;
      }
    }
  }

  _focus() {
    this.tag('Border').visible = true;
    this.signal('centerVertical', this.finalY + this.finalH * 0.5);
    if (this.fadeOut) {
      this.setSmooth('alpha', 1);
    }
  }

  _unfocus() {
    this.tag('Border').visible = false;
    if (this.fadeOut) {
      this.setSmooth('alpha', CmsConstants.Animation.fadeOut);
    }
  }

  _inactive() {
    // Disable autoscroll when off-screen
    if (this._autoscroll) Registry.clearTimeout(this._autoscroll);
  }

  _active() {
    // Turn on autoscroll when banner comes on screen
    if (this.ImageContainer.childList.length > 1 && this.data.banners[this._ImageIndex].time > 0) {
      this._autoscroll = Registry.setTimeout(this.moveRight.bind(this), this.data.banners[this._ImageIndex].time);
    }
  }

  showNextImage(currentIndex, newIndex) {
    // console.log('ShowNextImage');
    if (this._autoscroll) Registry.clearTimeout(this._autoscroll);

    this.ImageContainer.childList.getAt(currentIndex).setSmooth('alpha', 0, { duration: 1 });
    this.ImageContainer.childList.getAt(newIndex).setSmooth('alpha', 1, { duration: 1 });

    this.DotBar.updateUI(currentIndex, newIndex);

    if (this.data.banners[newIndex].time > 0) {
      this._autoscroll = Registry.setTimeout(this.moveRight.bind(this), this.data.banners[newIndex].time);
    }

    this._ImageIndex = newIndex;
  }

  moveRight() {
    if (this.ImageContainer.childList.length === 1) return;
    if (this._ImageIndex === this.ImageContainer.childList.length - 1) {
      this.showNextImage(this._ImageIndex, 0);
    } else {
      this.showNextImage(this._ImageIndex, this._ImageIndex + 1);
    }
  }

  _handleLeft() {
    if (this.data.banners.length === 1) {
      return false;
    }
    if (this._ImageIndex === 0) {
      return false;
      // this.showNextImage(this._ImageIndex, this.ImageContainer.childList.length - 1);
    } else {
      this.showNextImage(this._ImageIndex, this._ImageIndex - 1);
    }
  }

  _handleRight() {
    this.moveRight();
  }

  _handleEnter() {
    const action = this.data.banners[this._ImageIndex].action;
    CmsActionResolver.doAction(this, action, this.data.backend);
    return true;
  }

  // _handleUp() {
  //   if (this._autoscroll) Registry.clearTimeout(this._autoscroll);
  // }
}
